import franklinFloorplanSvgUrl from "./assets/franklinoffice.svg?url";
import lahoreFloorplanSvgUrl from "./assets/lahoreoffice.svg?url";
import type { SageOfficeView } from "../../admin/sage-offices/types";

/**
 * Maps a Sage office to its floorplan SVG.
 *
 * - Lahore → `lahoreoffice.svg`
 * - Franklin (and other / unmatched offices) → `franklinoffice.svg`
 */
export function resolveFloorplanSvgUrl(officeName: string): string | null {
    const n = officeName.trim().toLowerCase();
    if (n.length === 0) return null;
    if (n.includes("lahore")) return lahoreFloorplanSvgUrl;
    if (n.includes("franklin")) return franklinFloorplanSvgUrl;
    // Fallback so oddly named office records still open a map.
    return franklinFloorplanSvgUrl;
}

/** Offices that have a dedicated floorplan SVG (Lahore / Franklin by name). */
export function officesWithFloorplan(
    offices: readonly SageOfficeView[],
): readonly SageOfficeView[] {
    return offices.filter((o) => {
        const n = o.name.trim().toLowerCase();
        return n.includes("lahore") || n.includes("franklin");
    });
}
